import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=56a117b6&scoped=true&"
import script from "./EmptyData.vue?vue&type=script&lang=js&"
export * from "./EmptyData.vue?vue&type=script&lang=js&"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=56a117b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a117b6",
  null
  
)

export default component.exports